"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterCategories = filterCategories;
/**
 * Filter for users firstname, lastname and email
 */
var userSearchFilter = function (user, searchString, filters) {
    var nameColumn = "".concat(user.firstName || '', " ").concat(user.lastName || '', " ").concat(user.email).toLocaleLowerCase();
    var filterPairs = Object.entries(filters || {});
    if (filters && filterPairs.length > 0) {
        for (var _i = 0, filterPairs_1 = filterPairs; _i < filterPairs_1.length; _i++) {
            var _a = filterPairs_1[_i], filter = _a[0], value = _a[1];
            var val = (value || '').toLocaleLowerCase();
            switch (filter) {
                case 'user': {
                    if (nameColumn.indexOf(val) === -1) {
                        return false;
                    }
                    continue;
                }
                case 'company': {
                    if ("".concat(user.company).toLocaleLowerCase().indexOf(val) === -1) {
                        return false;
                    }
                    continue;
                }
                default:
                    continue;
            }
        }
    }
    return searchString.length > 0
        ? nameColumn.indexOf(searchString) !== -1
        : true;
};
/**
 * Filter for mapped categories name and members (using userSearchFilter)
 */
function filterCategories(userGroups, searchString, filters, featureFilter) {
    searchString = searchString.toLocaleLowerCase();
    return userGroups
        .map(function (item) { return ({
        category: __assign(__assign({}, item.category), { members: item.category.members.length > 0
                ? item.category.members.filter(function (member) {
                    return userSearchFilter(member, searchString, filters);
                })
                : [] }),
        groups: item.groups
            .map(function (group) {
            var categoryNameMatch = item.category.name.toLowerCase().indexOf(searchString) !== -1;
            var userProfileNameMatch = group.name.toLowerCase().indexOf(searchString) !== -1;
            var memberMatches = group.members.filter(function (member) {
                return userSearchFilter(member, searchString, filters) ||
                    userProfileNameMatch ||
                    categoryNameMatch;
            });
            if ((memberMatches.length > 0 && !userProfileNameMatch) ||
                userProfileNameMatch ||
                categoryNameMatch) {
                return __assign(__assign({}, group), { id: group.id, uuid: group.uuid, name: group.name, type: group.type, members: memberMatches.length > 0 ? memberMatches : group.members });
            }
            // Return non-matches with dummy id to filter with
            return __assign(__assign({}, group), { id: -1, uuid: group.uuid, name: group.name, type: group.type, members: group.members });
        })
            .filter(function (group) {
            return group.id > 0;
        })
    }); })
        .filter(function (item) {
        return (featureFilter !== undefined
            ? featureFilter.findIndex(function (x) {
                return item.category.features.includes(x);
            }) > -1
            : true) &&
            (item.category.name.toLowerCase().indexOf(searchString) !== -1 ||
                item.groups.length > 0 ||
                item.category.members.length > 0);
    });
}
